/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ISingleSystemSetupParameter } from './ISingleSystemSetupParameter';
import {
    ISingleSystemSetupParameterFromJSON,
    ISingleSystemSetupParameterFromJSONTyped,
    ISingleSystemSetupParameterToJSON,
} from './ISingleSystemSetupParameter';

/**
 * 
 * @export
 * @interface MedicalSystemSetupDto
 */
export interface MedicalSystemSetupDto {
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemSetupDto
     */
    targetSystemEntityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalSystemSetupDto
     */
    isSingleSetupParameterListReadOnly?: boolean;
    /**
     * 
     * @type {Array<ISingleSystemSetupParameter>}
     * @memberof MedicalSystemSetupDto
     */
    singleSetupParameters: Array<ISingleSystemSetupParameter>;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemSetupDto
     */
    $type?: MedicalSystemSetupDtoTypeEnum;
}


/**
 * @export
 */
export const MedicalSystemSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoMedicalSystemSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type MedicalSystemSetupDtoTypeEnum = typeof MedicalSystemSetupDtoTypeEnum[keyof typeof MedicalSystemSetupDtoTypeEnum];


/**
 * Check if a given object implements the MedicalSystemSetupDto interface.
 */
export function instanceOfMedicalSystemSetupDto(value?: unknown): value is MedicalSystemSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(MedicalSystemSetupDtoTypeEnum)[0];
}

export function MedicalSystemSetupDtoFromJSON(json: any): MedicalSystemSetupDto {
    return MedicalSystemSetupDtoFromJSONTyped(json, false);
}

export function MedicalSystemSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemSetupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetSystemEntityId': !exists(json, 'targetSystemEntityId') ? undefined : json['targetSystemEntityId'],
        'isSingleSetupParameterListReadOnly': !exists(json, 'isSingleSetupParameterListReadOnly') ? undefined : json['isSingleSetupParameterListReadOnly'],
        'singleSetupParameters': ((json['singleSetupParameters'] as Array<any>).map(ISingleSystemSetupParameterFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function MedicalSystemSetupDtoToJSON(value?: MedicalSystemSetupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetSystemEntityId': value.targetSystemEntityId,
        'isSingleSetupParameterListReadOnly': value.isSingleSetupParameterListReadOnly,
        'singleSetupParameters': ((value.singleSetupParameters as Array<any>).map(ISingleSystemSetupParameterToJSON)),
        '$type': value.$type,
    });
}

